import { createRoutine } from 'redux-saga-routines';

const FETCH_FAVOURITE_PROPERTIES_ACTION_PREFIX = 'FETCH_FAVOURITE_PROPERTIES_ACTION';
export const fetchFavouritePropertiesAction = createRoutine(FETCH_FAVOURITE_PROPERTIES_ACTION_PREFIX);
